<script lang="ts">
  import Icon from "./Icon.svelte";
  import type { TableHeaderType } from "../../types/Components";
  import type { PageData } from "../../types/PageData";

  export let header: TableHeaderType;
  export let page: PageData;
  export let handleSortClick;

  let params, sortIconType, transformStyle;

  $: {
    params = {
      direction:
        page.params.sort == header.sortName && page.params.direction == "ASC" ? "DESC" : "ASC",
      sort: header.sortName,
    };

    sortIconType =
      page.params.sort && page.params.direction && header.sortName == page.params.sort
        ? "SortArrow"
        : "DoubleArrow";
    transformStyle =
      header.sortName == page.params.sort && page.params.direction == "ASC"
        ? "transform: rotate(180deg)"
        : "";
  }

</script>

<th style={`width: ${header.width}%`} class="fizz-hide-on-small">
  {#if header.sortable == true}
    <button
      on:click|preventDefault={() => handleSortClick(params)}
      style="color: black;"
      id={header.name + "-sort_link"}
    >
      {header.name}
      <Icon
        type={sortIconType}
        height={14}
        width={14}
        extraStyles={`display: inline-block; ${transformStyle}`}
        fill={sortIconType == "DoubleArrow" ? "#d9d9d9" : null}
      />
    </button>
  {:else}
    {header.name}
  {/if}
</th>
